var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancelCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.041,
    height: 49.041,
    viewBox: "0 0 49.041 49.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel",
    "data-name": "Icon material-cancel",
    d: "M27.521,3A24.521,24.521,0,1,0,52.041,27.521,24.5,24.5,0,0,0,27.521,3Zm12.26,33.323-3.457,3.457-8.8-8.8-8.8,8.8L15.26,36.323l8.8-8.8-8.8-8.8,3.457-3.457,8.8,8.8,8.8-8.8,3.457,3.457-8.8,8.8Z",
    transform: "translate(-3 -3)",
    fill: "#a50808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelCircle);
export default __webpack_public_path__ + "static/media/IconCancelCircle.7dbf6ab8c65c9e1d93c71862ab877495.svg";
export { ForwardRef as ReactComponent };